import { ORPCError } from "@orpc/client";
import { useRouteContext } from "@tanstack/react-router";
import { calculatePermission } from "@workspace/admin-domain/src/utils";
import type { TPermission } from "@workspace/domain/src/utils/permissions";
import type { TRouteContext } from "./types";

export function requirePermissions(
  permissions: TPermission[] | TPermission | true,
) {
  return ({ context }: { context: TRouteContext<true> }) => {
    if (permissions === undefined) return;
    const hasPermission = calculatePermission({
      requiredPermissions:
        typeof permissions === "string" ? [permissions] : permissions,
      auth: context.auth,
    });

    if (!hasPermission) {
      throw new ORPCError("FORBIDDEN");
    }
  };
}

export function useHasPermission(
  permission: TPermission[] | TPermission | true,
) {
  const context = useRouteContext({ from: "/_authenticated" });
  return calculatePermission({
    requiredPermissions:
      typeof permission === "string" ? [permission] : permission,
    auth: context.auth,
  });
}
